module.exports = __webpack_public_path__ + "img/4.5c954785.jpg";